module.exports = __webpack_public_path__ + "static/assets/dd48671e3fe3578db6948c38428e2405.svg";